import { render, staticRenderFns } from "./SignInWithEmail.vue?vue&type=template&id=987175f2&lang=pug"
import script from "./SignInWithEmail.vue?vue&type=script&lang=ts"
export * from "./SignInWithEmail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LogoLoadsureTagline: require('/workspace/portal/hosting/components/LogoLoadsureTagline.vue').default})
